module.exports = __webpack_public_path__ + "img/img28.d352053c.svg";